import { Row, Col } from 'react-bootstrap';
import { getProbabilityOfDamageOrHigher } from '../../../../hooks/useAttackEvaluation/useAttackEvaluation.util';

import style from '../DamageDisplay/DamageDisplay.module.css';
import { useMemo } from 'react';

interface AverageDamageProps {
    damageDistribution: number[];
    averageDamage: number;
}

function AverageDamage({ damageDistribution, averageDamage }: AverageDamageProps) {
  const maxLikelyDamage = useMemo(() => {
    let max = 0;
    damageDistribution.forEach((_, i) => {
      if(getProbabilityOfDamageOrHigher(damageDistribution, i) > (1 / 10 ** 2)) {
        max = i;
      }
    });
    
    return max;
  }, [damageDistribution]);

  return (
    <>
      <Row>
        <Col xs={8}>
          <span className={`${style.outputTitle} ${style.outputText}`}>Average damage:</span>
        </Col>
        
        <Col>
          <span className={`${style.outputText}`}>{averageDamage.toFixed(2)}</span>
        </Col>
      </Row>
        
      <Row>
        <Col xs={8}>
          <span className={`${style.outputTitle} ${style.outputText}`}>Chance of doing {Math.floor(averageDamage)} damage or better:</span>
        </Col>
        
        <Col>
          <span className={`${style.outputText}`}> {getProbabilityOfDamageOrHigher(damageDistribution, Math.floor(averageDamage)).toLocaleString(undefined,{style: 'percent', minimumFractionDigits:2})}</span>
        </Col>
      </Row>
        
      <Row className="mb-3">
        <Col xs={8}>
          <span className={`${style.outputTitle} ${style.outputText}`}>{'Max likely damage (>1% chance):'}</span>
        </Col>
        
        <Col>
          <span className={`${style.outputText}`}> {maxLikelyDamage}</span>
        </Col>
      </Row>
    </>
  );
}

export default AverageDamage;